var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "74e0c05e-b367-4892-8122-b50684a104ec",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.14,
    height: 98.11,
    viewBox: "0 0 103.14 98.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc6e8213-e499-4f8d-84e8-eae0902459b4",
    x1: 23.54,
    y1: 579.34,
    x2: 42.42,
    y2: 579.34,
    gradientTransform: "translate(1.8 -514.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8c21bbf-d16c-416d-8345-ec847a1fae97",
    x1: 14.33,
    y1: 540.71,
    x2: 70.55,
    y2: 540.71,
    xlinkHref: "#bc6e8213-e499-4f8d-84e8-eae0902459b4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "26204dc6-496f-4de5-9339-53b110e58262",
    x1: 53.22,
    y1: 540.71,
    x2: 75.51,
    y2: 540.71,
    gradientTransform: "translate(1.8 -514.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff89a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e81760f-d10b-42fa-b877-fe7815648c89",
    x1: 4.74,
    y1: 540.71,
    x2: 15.2,
    y2: 540.71,
    gradientTransform: "translate(1.8 -514.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#faf7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3eae6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3c1ff002-d810-4ac4-92f1-82421a10c987",
    x1: -4,
    y1: 540.71,
    x2: 10.07,
    y2: 540.71,
    gradientTransform: "translate(1.8 -514.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e41f2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "80bc63c1-1022-4e42-b4fa-c440a34b9fa3",
    x1: 74.62,
    y1: 30.72,
    x2: 92.15,
    y2: 13.19,
    gradientTransform: "matrix(1, 0, 0, -1, 1.8, 102.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4110f98f-2049-4bc2-9393-1c37f3e437be",
    x1: 95.27,
    y1: 9.87,
    x2: 82.27,
    y2: 22.86,
    gradientTransform: "matrix(1, 0, 0, -1, 1.8, 102.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63950",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#e4354b",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d31822",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c90709",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5fc7582-d88c-4237-b606-fd5dd0b1e59b",
    x1: 78.94,
    y1: 26.2,
    x2: 86.63,
    y2: 18.51,
    gradientTransform: "matrix(1, 0, 0, -1, 1.8, 102.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "orderRejected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M34.25,80.15a3.92,3.92,0,0,1-3.92-3.91V64.41a12.11,12.11,0,0,0-4.9-9.74H45.6V68.8A11.35,11.35,0,0,1,34.25,80.15Z",
    style: {
      fill: "url(#bc6e8213-e499-4f8d-84e8-eae0902459b4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,50a7.3,7.3,0,0,1-7.3,7.3H31.85a9.36,9.36,0,0,1-6.42-2.58,20.38,20.38,0,0,0-13.78-5.59h0V8.18h0a20.39,20.39,0,0,0,13.78-5.6A9.36,9.36,0,0,1,31.85,0H69.22a7.3,7.3,0,0,1,5.69,11.87,4,4,0,0,0,0,5.08,7.28,7.28,0,0,1,0,9.13,4,4,0,0,0,0,5.09,7.28,7.28,0,0,1,0,9.13,4,4,0,0,0,0,5.08A7.24,7.24,0,0,1,76.52,50Z",
    style: {
      fill: "url(#e8c21bbf-d16c-416d-8345-ec847a1fae97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,50a7.3,7.3,0,0,1-7.3,7.3H61a7.3,7.3,0,0,0,5.7-11.87,4,4,0,0,1,0-5.08,7.28,7.28,0,0,0,0-9.13,4,4,0,0,1,0-5.08,7.29,7.29,0,0,0,0-9.14,4,4,0,0,1,0-5.08A7.3,7.3,0,0,0,61,0h8.22a7.3,7.3,0,0,1,5.69,11.87,4,4,0,0,0,0,5.08,7.28,7.28,0,0,1,0,9.13,4,4,0,0,0,0,5.09,7.28,7.28,0,0,1,0,9.13,4,4,0,0,0,0,5.08A7.24,7.24,0,0,1,76.52,50Z",
    style: {
      fill: "url(#26204dc6-496f-4de5-9339-53b110e58262)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77,3.11v51H12.5a5.81,5.81,0,0,0,5.81-5.81V8.92A5.81,5.81,0,0,0,12.5,3.11Z",
    style: {
      fill: "url(#9e81760f-d10b-42fa-b877-fe7815648c89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.18,3.73V53.52a3.73,3.73,0,0,0,3.73,3.73,5.81,5.81,0,0,0,5.81-5.81V5.81A5.81,5.81,0,0,0,3.91,0,3.73,3.73,0,0,0,.18,3.73Z",
    style: {
      fill: "url(#3c1ff002-d810-4ac4-92f1-82421a10c987)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.21,
    cy: 79.85,
    r: 18.26,
    style: {
      fill: "url(#80bc63c1-1022-4e42-b4fa-c440a34b9fa3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,70.19l-5.32,5.33-5.32-5.33a3,3,0,0,0-4.56.15,3.19,3.19,0,0,0,.16,4.71l5.17,5.17-5.17,5a3.38,3.38,0,0,0-.31,4.86L83.09,98a18.57,18.57,0,0,0,2.12.12,18.26,18.26,0,0,0,18.26-18.26c0-.56,0-1.11-.08-1.66L95.24,70a3.19,3.19,0,0,0-4.71.15Z",
    style: {
      fill: "url(#4110f98f-2049-4bc2-9393-1c37f3e437be)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.22,80.07l5-5a3.54,3.54,0,0,0-5-5l-5,5-5-5a3.54,3.54,0,0,0-5,5l5,5-5,5a3.55,3.55,0,0,0,5,5l5-5,5,5a3.55,3.55,0,1,0,5-5Z",
    style: {
      fill: "url(#b5fc7582-d88c-4237-b606-fd5dd0b1e59b)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderRejected);
export default __webpack_public_path__ + "static/media/orderRejected.5cb00678.svg";
export { ForwardRef as ReactComponent };